(() => {
  if (window.__epAovAddonsReady) return;
  window.__epAovAddonsReady = true;

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-addon-variant], [data-addon-bundle]');
    if (!input || !input.checked) return;
    const group = input.closest('[data-ep-addons]');
    if (!group) return;
    if (input.hasAttribute('data-addon-bundle')) {
      group.querySelectorAll('[data-addon-variant]').forEach((box) => { box.checked = false; });
    } else {
      const bundle = group.querySelector('[data-addon-bundle]');
      if (bundle) bundle.checked = false;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const checked = [...form.querySelectorAll('[data-addon-variant]:checked')];
    const bundle = form.querySelector('[data-addon-bundle]:checked');
    if (!checked.length && !bundle) return;

    const mainVariant = form.querySelector('input[name="id"]')?.value;
    if (!mainVariant) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const submit = form.querySelector('[type="submit"]');
    const originalText = submit?.textContent;
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Adding your guides…';
    }

    const quantity = Number(form.querySelector('input[name="quantity"]')?.value || 1);
    const addonIds = bundle
      ? bundle.dataset.addonBundle.split(',').filter(Boolean)
      : checked.map((box) => box.dataset.addonVariant);
    const items = [
      { id: Number(mainVariant), quantity },
      ...addonIds.map((id) => ({ id: Number(id), quantity: 1 }))
    ];

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(`${root}cart`);
    } catch (error) {
      if (submit) {
        submit.disabled = false;
        submit.textContent = originalText || 'Add to cart';
      }
      const note = form.querySelector('.ep-addons__note');
      if (note) note.textContent = 'We could not add the companion guides. Please try again.';
    }
  }, true);
})();
